import * as Yup from 'yup';

export const holidayFormSchema = Yup.object().shape({
  holidayName: Yup.string().required('Holiday name is required'),
  holidayDate: Yup.string().required('Holiday date is required'),
});
